import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles';

const CoursesOverviewStyles = makeStyles()((theme: Theme) => ({
	root: {
		marginTop: theme.spacing(4),
		marginBottom: theme.spacing(6),
	},

	notificationSection: {
		marginBottom: theme.spacing(5),
	},

	sliderContainer: {
		position: 'relative',
		width: '100%',
		overflow: 'hidden',
	},

	sliderTrack: {
		width: '100%',
		overflow: 'hidden',
		padding: theme.spacing(0, 6),
	},

	sliderContent: {
		display: 'flex',
		width: '100%',
	},

	sliderHeader: {
		marginBottom: theme.spacing(2),
	},

	sliderItem: {
		flex: '0 0 100%',
		padding: theme.spacing(1),
		height: '100%',
		boxSizing: 'border-box',
	},

	sliderDots: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		gap: theme.spacing(1),
		marginTop: theme.spacing(2),
	},

	sliderDot: {
		width: 10,
		height: 10,
		borderRadius: '50%',
		transition: 'background-color 0.3s ease',
	},

	sliderNavButton: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[2],
		border: `1px solid ${theme.palette.divider}`,
		'&:hover': {
			backgroundColor: 'white',
			boxShadow: theme.shadows[4],
		},
		'&.Mui-disabled': {
			opacity: 0.3,
			cursor: 'not-allowed',
		},
	},

	notificationCard: {
		borderRadius: theme.spacing(2),
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		position: 'relative',
	},

	notificationCloseButton: {
		position: 'absolute',
		top: theme.spacing(1),
		right: theme.spacing(1),
		backgroundColor: 'rgba(255, 255, 255, 0.9)',
		zIndex: 1,
		'&:hover': {
			backgroundColor: 'rgba(255, 255, 255, 1)',
		},
	},

	notificationMedia: {
		width: '100%',
		height: 160,
		objectFit: 'cover',
	},

	notificationContent: {
		flexGrow: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing(1),
	},

	notificationTitle: {
		fontWeight: 600,
	},

	notificationDescription: {
		color: theme.palette.text.secondary,
	},

	notificationActions: {
		paddingLeft: theme.spacing(3),
		paddingBottom: theme.spacing(3),
	},

	gridContainer: {
		marginTop: theme.spacing(3),
	},
}));

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export default CoursesOverviewStyles;
